/**
 * formatLineSelections.ts — Resumen de variantes/modificadores para tickets y UI.
 *
 * Módulo neutral compartido entre Caja, Tienda y tickets.
 */

export type VarianteSeleccionada = {
  groupId: string;
  groupLabel: string;
  optionId: string;
  optionLabel: string;
  /** Cargo fijo de la opción SKU (igual que modificadores). */
  precioExtra?: number;
};

export type ModificadorSeleccionado = {
  groupId: string;
  groupLabel: string;
  optionId: string;
  optionLabel: string;
  precioExtra?: number;
};

export type LineSelectionsCarrier = {
  variantesSeleccionadas?: VarianteSeleccionada[];
  modificadoresSeleccionados?: ModificadorSeleccionado[];
};

export const formatModifierSummary = (
  mods?: ModificadorSeleccionado[],
): string => {
  if (!mods?.length) return "";
  const counts = new Map<string, { label: string; n: number }>();
  for (const m of mods) {
    const prev = counts.get(m.optionId);
    if (prev) prev.n += 1;
    else counts.set(m.optionId, { label: m.optionLabel, n: 1 });
  }
  return [...counts.values()]
    .map(({ label, n }) => (n > 1 ? `${label} x${n}` : label))
    .join(" · ");
};

export const formatVariantSummary = (
  variantes?: VarianteSeleccionada[],
): string => {
  if (!variantes?.length) return "";
  return variantes.map((v) => `${v.groupLabel}: ${v.optionLabel}`).join(" · ");
};

/** Variantes + modificadores en una sola línea para ticket/carrito */
export const formatSelectionsSummary = (
  item: LineSelectionsCarrier,
): string => {
  const parts: string[] = [];
  const variantText = formatVariantSummary(item.variantesSeleccionadas);
  if (variantText) parts.push(variantText);
  const modText = formatModifierSummary(item.modificadoresSeleccionados);
  if (modText) parts.push(modText);
  return parts.join(" · ");
};
